import React, {useState, useEffect} from "react";
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import moment from "moment";
import { Link } from "react-router-dom";
//import "./../../Public/css/bootstrap.min.css";
//import "./../../Public/css/tabler-icons.css";
//import "./../../Public/css/fontawesome.min.css";
//import "./../../Public/css/all.min.css";
//import "./../../Public/css/style.css";

import {DashboardAPI, DashboardFilterAPI, getCampaignsAPI, getCallersAPI, LeadAutoAssignAPI, ImportGoogleDriveLeadsAPI, ExportLeadsToGoogleDriveAPI, getFilterCallerStats} from "./../../API/Team/DashboardAPI";
//import Sidebar from "./Common/Sidebar";
//import Header from "./Common/Header";
//import Loader from "./../Loader";
import Layout from "./Layout";
import ContentLoader from "../../utils/ContentLoader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactSelect from 'react-select';
import { format } from "date-fns";


const Dashboard = () =>{

	const [freshleadcount, setFreshLeadCount] = useState(0);
	const [warmleadcount, setWarmLeadCount] = useState(0);
	const [todayfollowup, setTodayFollowup] = useState(0);
	const [pendingfollowup, setPendingFollowup] = useState(0);

	/*const [contactedleadcount, setContactedLeadCount] = useState(0);
	const [deadleadcount, setDeadLeadCount] = useState(0);
	const [coldleadcount, setColdLeadCount] = useState(0);
	const [attemptleadcount, setAttemptLeadCount] = useState(0);
	const [enrolledleadcount, setEnrolledLeadCount] = useState(0);
	const [totalleadcount, setTotalLeadCount] = useState(0);*/
	
	const [loggedname, setLoggedName] = useState("");

	const [callerdata, setCallerData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [notifications, setNotifications] = useState([]);
	const [campaigns, setCampaigns] = useState([]);
	const [callers, setCallers] = useState([]);
	const [filtercampaign, setFilterCampaign] = useState("");
	const [filtercaller, setFilterCaller] = useState("");
	const [filterstartdate, setFilterStartdate] = useState("");
	const [filterenddate, setFilterEnddate] = useState("");
	const [filterparam, setFilterParam] = useState("");
	const [btnimportloader, setBtnImportLoader] = useState(false);
	const [btnexportloader, setBtnExportLoader] = useState(false);
	
	const [createdstartdate, setCreatedStartDate] = useState(null);
	const [createdenddate, setCreatedEndDate] = useState(null);

	const [callerstatstartdate, setCallerStatStartDate] = useState(null);
	const [callerstatenddate, setCallerStatEndDate] = useState(null);

	const [reload, setReload] = useState(false);
	const [btnrefreshloader, setBtnRefreshLoader] = useState(false);

	const [filtersStored, setFiltersStored] = useState(null);
	const [topfiltersDraft, setTopFiltersDraft] = useState({ 
                                                    filtercaller: "",
                                                    filtercreatedstartdate: "",
                                                    filtercreatedenddate: ""
                                                });

	const current = moment();



	useEffect(() =>{

		const userinfo = localStorage.getItem("userinfo");

		if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
        }

		//DashboardAPI(setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading);

		//getCampaignsAPI(setCampaigns);

		getCallersAPI(setCallers);
		
	}, []);

	useEffect(() => {
                
        console.log("Step 2");
        const params = new URLSearchParams();
        
        
        if (filtersStored)
        {
            console.log("Step 3");
                
            Object.keys(filtersStored).forEach(key => {
                if (filtersStored[key]) {
                    params.append(key, filtersStored[key]);
                }
            });
        }

        console.log("Step 4");

        //params.append("page", currentPage);
        //params.append("per_page", perpagedata);
        console.log(">>>>>" + JSON.stringify(params));

        DashboardAPI(setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading, params);

        //DashboardAPI(setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading, params);

        //DashboardFilterAPI(params, setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setLoading);

    }, [filtersStored]);

	const handleReloadStats = () =>{
		setBtnRefreshLoader(true);		

		DashboardAPI(setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading, null);

		setReload(prev => !prev);
	}

	const handleFilterCaller = (selcaller) =>{
		//setFilterCaller(e.target.value);

		console.log('Filter caller====' + JSON.stringify(selcaller));

        setFilterCaller(selcaller);

        if(selcaller)
        {

            const callerid = selcaller?.value ?? "";


            setTopFiltersDraft(prev => ({
                                ...prev,
                                filtercaller: callerid
                            }));

            //setFilterCaller(campaignvalue);
        }
	}

	const handleStartDate = (e) =>{
		setFilterStartdate(e.target.value);
	}

	const handleEndDate = (e) =>{
		setFilterEnddate(e.target.value);
	}

	const handleFilterDashboardCounts = (e) =>{

        console.log('Filter Campaign====' + filtercampaign);
        console.log('Filter Caller====' + filtercaller);
        console.log('Filter Start Date====' + filterstartdate);
        console.log('Filter End Date====' + filterenddate);

        setFiltersStored({ ...topfiltersDraft });
	}

	const handleClearFilterDashboard = () =>{


		setFilterCaller("");
		setFilterStartdate("");
		setFilterEnddate("");

		setCreatedStartDate("");
        setCreatedEndDate("");


		setTopFiltersDraft({
                    filtercaller: "",
                    filtercreatedstartdate: "",
                    filtercreatedenddate: ""
        });

        setFiltersStored(null);

		DashboardAPI(setFreshLeadCount, setWarmLeadCount, setPendingFollowup, setTodayFollowup, setNotifications, setCallerData, setLoading, null);
	}

	const handleAutoAssignLeads = () =>{

		LeadAutoAssignAPI();
	}

	const handleGoogleDriveLeads = () =>{

		ImportGoogleDriveLeadsAPI();
	}

	const handleExportLeadsGoogleDrive = () =>{
		ExportLeadsToGoogleDriveAPI();
	}

	const handleCallerStatDateRange = (seldates) => {

        console.log("Caller Stats Dates====" + seldates);

        if(!seldates || (!seldates[0] && !seldates[1]))
        {
            
            console.log("caller stats false condition");

            setCallerStatStartDate("");
            setCallerStatEndDate("");
            getFilterCallerStats(setCallerData, null);
           	
        }
        else
        {
            console.log("caller stats true condition");

            const [startdate, enddate] = seldates;

            setCallerStatStartDate(startdate);
            setCallerStatEndDate(enddate);

            if (startdate && enddate) 
           	{
           		const datefilter = { filterstartdate:  format(startdate, "yyyy-MM-dd"), filterenddate: format(enddate, "yyyy-MM-dd") }

        		getFilterCallerStats(setCallerData, datefilter);
    		}
            

        }

    }

    const handleCreatedDateRange = (dates) => {

        console.log("Created Dates====" + dates);

        if(!dates || (!dates[0] && !dates[1]))
        {
            
            console.log("created false condition");
            
            setCreatedStartDate("");
            setCreatedEndDate("");

            setTopFiltersDraft(prev => ({
                                ...prev,
                                filtercreatedstartdate: "",
                                filtercreatedenddate: ""
                            }));
        }
        else
        {
            console.log("created true condition");
            
            const [startdate, enddate] = dates;

            setCreatedStartDate(startdate);
            setCreatedEndDate(enddate);

            setTopFiltersDraft(prev => ({
                                ...prev,
                                filtercreatedstartdate: format(startdate, "yyyy-MM-dd"),
                                filtercreatedenddate: format(enddate, "yyyy-MM-dd")
                            }));

        }

    }

    



    return(
	<Layout>
		<div className="content">
			<div class="welcome-wrap mb-4">
				<div class=" d-flex align-items-center justify-content-between flex-wrap crm-welcome-bar">
					<div class="mb-3">
						<h2 class="mb-1 text-white">Welcome {loggedname}</h2>
						<p class="text-light">As of {current.format('DD MMMM YYYY')} {current.format('hh:mm A')}</p>
					</div>
					
					<div class="d-flex align-items-center flex-wrap mb-1 crm-top-actions">
						{/*<a href="company.html" class="btn btn-dark btn-md me-2 mb-2">Companies</a>*/}
						{/*<button type="button" class="btn btn-light btn-md mb-2 mx-2" onClick={handleReloadStats}>Refresh</button>*/}

						<button type="button" class="btn btn-primary crm-refresh-btn" onClick={handleReloadStats}>
							<i className={`ti ti-refresh me-1 ${btnrefreshloader ? 'spin' : ''}`}></i>Refresh Data
						</button>

						{/*<button type="button" class="btn btn-light btn-md mb-2 mx-2" onClick={handleAutoAssignLeads}>Auto Lead Assign</button>
					
						<button type="button" class="btn btn-light btn-md mb-2 mx-2" onClick={handleGoogleDriveLeads}>Import Google Drive Leads</button>
						
						<button type="button" class="btn btn-light btn-md mb-2" onClick={handleExportLeadsGoogleDrive}>Export Leads Google Drive</button>*/}
						
						
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-md-12">
					<div className="page-header">
						<div className="align-items-center ">
							<div className="col-md-12 ms-auto">
								<div className="d-flex title-head crm-filter-row">
									{/*<div className="crm-filter-item">
										<ReactSelect className="" value={filtercampaign} onChange={handleFilterCampaign} options={campaigns} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Campaigns"></ReactSelect>										
									</div>*/}

									<div className="crm-filter-item">
										<ReactSelect className="" value={filtercaller} onChange={handleFilterCaller} options={callers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Caller"></ReactSelect>										
									</div>
									
									{/*<div className="crm-filter-item">
										<DatePicker className="form-control" selected={createdstartdate} onChange={ handleCreatedDateRange } startDate={createdstartdate} endDate={createdenddate} selectsRange isClearable placeholderText="Created Date" />

									</div>*/}
									{/*<div className="crm-filter-item">
										<input type="date" className="form-control" name="enddate" value={filterenddate} onChange={handleEndDate} />
									</div>*/}

									<div className="crm-filter-item button-filter me-2">
										<button type="button" className="btn btn-success" onClick={handleFilterDashboardCounts}>
											<i className="ti ti-search me-2"></i>Apply Filter
										</button>
										
										<button type="button" className="btn btn-dark" onClick={handleClearFilterDashboard}>
											<i className="ti ti-x me-2"></i>Clear Filter
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row crm-stats-row">
				<div className="col-md-3">
					<div className="card fresh">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{freshleadcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Fresh Leads</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/lead/freshlead${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-3">
					<div className="card follow">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{todayfollowup}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Follow Up for Today</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/notification/today${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="card warm">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{warmleadcount}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Warm Leads</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/lead/warmleads${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg  className="icon" xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

				<div className="col-md-3">
					<div className="card pending">
						<div className="card-body p-3 d-flex align-items-center mx-auto">
							<div>
								<div className="fs-25 fw-semibold widget-text text-center">{pendingfollowup}</div>
								<div className="text-body-secondary fw-semibold widget-heading">Pending Follow Ups</div>
							</div>
						</div>
						<div className="card-footer px-3 py-2">
							<div class="footer-content">
								<Link className="btn-block text-body-secondary d-flex justify-content-between align-items-center" to={`/team/notification/pending${filterparam}`}>
									<span className="small fw-semibold">View all</span>
									<span>
										<svg xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right">
											<path stroke="none" d="M0 0h24v24H0z" fill="none"/>
											<path d="M5 12l14 0" />
											<path d="M13 18l6 -6" />
											<path d="M13 6l6 6" />
										</svg>
									</span>
								</Link>
							</div>
						</div>
					</div>
				</div>

			</div>

			<div className="row crm-report-row">
				<div className="col-md-8">
					<div className="card w-100 crm-big-report-card">
						<div className="card-header border-0 pb-0 d-flex align-items-center justify-content-between flex-wrap gap-2">
							<h4 className="mb-2">
								<i className="ti ti-grip-vertical me-1"></i>Caller Leads Report
							</h4>
							<div classname="dropdown">
								<DatePicker className="form-control" selected={callerstatstartdate} onChange={ handleCallerStatDateRange } startDate={callerstatstartdate} endDate={callerstatenddate} selectsRange isClearable placeholderText="Filter Date" popperPlacement="bottom-end" popperStrategy="fixed" />								
							</div>
						</div>
						<div className="card-body">
							{loading ?
								<ContentLoader />
							:

							<div className="table-responsive crm-report-table-wrap">
								<table class="table table-nowrap mb-0">
									<thead class="thead-light">
										<tr>
											<th>Caller Name</th>
											<th>Assigned</th>
											<th>Warm</th>
											<th>Cold</th>
											<th>Dead</th>
											<th>Application</th>
											<th>Admission</th>
										</tr>
									</thead>
									<tbody>

									{
									callerdata && callerdata.length > 0  ?
										callerdata.map(caller =>
											(
												<tr key={caller.id}>
													<td>
														<div class="avatar avatar-sm border flex-shrink-0 me-2">
															<span class="initials">{(caller.name).slice(0,2)}</span>
														</div>
														{caller.name}
													</td>
													<td>{caller.assignedleadcount}</td>
													<td>{caller.warmcount}</td>
													<td>{caller.coldcount}</td>
													<td>{caller.deadcount}</td>
													<td>{caller.applicationcount}</td>
													<td>{caller.admissioncount}</td>
												</tr>

											)
										)

									:

										<p>
											<center>No records found</center>
										</p>
									}

									</tbody>
								</table>
							</div>
							}
						</div>
					</div>
				</div>

				<div className="col-md-4">
					<div class="card flex-fill crm-right-card">
						<div class="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
							<h5 class="mb-2">Today Follow Ups</h5>
							<Link to="/team/notifications" class="btn btn-light btn-md mb-2">View All</Link>
						</div>
						<div class="card-body crm-followup-body">
							<div class="crm-followup-list">								
							{notifications && notifications.length > 0  ?
								( notifications.map(notification => 
									(
										<div key={notification.name} class="crm-followup-item">
											<div class="crm-followup-top">
												<span class="crm-followup-name">{notification.name}</span>
												<span class="crm-followup-time">{notification.display_time}</span>
											</div>
											<div class="crm-followup-bottom">
												<span class="crm-followup-mobile">{notification.contact}</span>
												<span class="crm-followup-date">{moment(notification.display_date).format('DD MMM YYYY')}</span>
											</div>
										</div>
									)
								))
							:
								<p className="centered-message">No data found</p>
							}
							</div>
						</div>
					</div>
				</div>					
			</div>
		</div>
	</Layout>
    )
}

export default Dashboard;
